import { createFileRoute, Outlet } from "@tanstack/react-router";
import { ensureCraftPagesAdminAccess } from "@/lib/auth/craft-pages-admin.guard";

export const Route = createFileRoute("/admin/pages")({
  beforeLoad: () => ensureCraftPagesAdminAccess(),
  component: () => <Outlet />,
});
